module.exports = __webpack_public_path__ + "97b6f3f1b702995a561a329965f38f19.png";